import SideMenu from "../core/side-menu";
import "./index.scss";
import { useState, useEffect } from "react";
import { IconButton } from "@mui/material";
import { BellCorpStudioLogoContainer } from "../../common-utilities/Bellcorp-Studio-Logo";
import Header from "../core/header";
import IntranetHeader from "../../../core/header";
import HomeRedirect from "../../common-utilities/core/home-redirect";
import { tokenMainKeys } from "../../../utils/constants";
import HeaderV2 from "../core/header-v2";

const MainContainer = ({
  children,
  reloadPendingApprovals,
  setReloadPendingApprovals,
}) => {
  const [showSideMenu, changeviewSettingsForSideMenu] = useState(true);
  const [open, setOpen] = useState(window.innerWidth > 480);

  return (
    <div className="subway-app-main-container">
      <div className="subway-app-main-header">
        <IntranetHeader />
      </div>
      <div className="subway-app-current-app-container">
        <div className="main-right-container">
          <HeaderV2
            appName="CF Approval"
            reloadPendingApprovals={reloadPendingApprovals}
            setReloadPendingApprovals={setReloadPendingApprovals}
          />
        </div>
        <div className="main-left-container">
          <div className="content-div">
            <div>{children}</div>
            <BellCorpStudioLogoContainer />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainContainer;
